import React, { FC, useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';
import styles from './termsAndConditionModal.module.scss';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import COButton from 'shared/components/COButton';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import { FormFieldsText } from './formFieldsText';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

interface TermsAndConditionModalProps {
  isModalOpen: boolean;
  hideModal: () => void;
  onAccept: () => void;
  onReject: () => void;
}

const TermsAndConditionModal: FC<TermsAndConditionModalProps> = props => {
  const { isModalOpen, hideModal, onAccept, onReject } = props;

  const [numPages, setNumPages] = useState<number>();
  const [loading, setLoading] = useState<boolean>();

  const pdfUrl = AppRoutes.TERMS_AND_CONDITION;

  useEffect(() => {
    const getNumPages = async () => {
      try {
        setLoading(true);
        const pdf = await pdfjs.getDocument(pdfUrl).promise;
        setNumPages(pdf.numPages);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    getNumPages();
  }, [pdfUrl]);

  return (
    <div className={styles.termsAndConditionModal}>
      <Modal
        className={styles.modalBody}
        wrapClassName={styles.modalContainer}
        destroyOnClose={true}
        open={isModalOpen}
        footer={null}
        onOk={onAccept}
        onCancel={hideModal}>
        <div className={styles.pdfViewer}>
          {loading ? (
            <Spin />
          ) : (
            <div>
              {numPages && (
                <Document file={pdfUrl}>
                  {Array.from({ length: numPages }, (_, index) => (
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                  ))}
                </Document>
              )}
            </div>
          )}
          <div className={styles.buttonContainer}>
            <COButton onClick={onAccept}>{FormFieldsText.ACCEPT}</COButton>
            <COButton secondary onClick={onReject}>
              {FormFieldsText.REJECT}
            </COButton>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default TermsAndConditionModal;
